<template>
  <el-dialog width="960px"
             top="5vh"
             custom-class="user-communicate-dialog"
             append-to-body
             :visible="visible"
             @close="closeAndRefresh()"
             :title="title">
    <el-form ref="communicateForm"
             :model="form"
             :rules="formRules"
             label-width="120px"
             size="medium">
      <div class="re-el-form__flex communicate-form-grid">
        <el-form-item label="用户手机号"
                      prop="userid">
          <remote-select v-model="form.userid"
                         class="width-max"
                         :disabled="lockUserId"
                         clearable
                         id-key="userid"
                         label-key="cellphone"
                         value-key="userid"
                         placeholder="请输入用户手机号"
                         :query-request="getUserTable"
                         :find-request="getUserDetail_">
          </remote-select>
        </el-form-item>
        <el-form-item >
          <template #label>
            <div class="workinfo-link-wrapper"
                 v-if="showWorkInfoLink">
              <el-button type="text"
                         class="workinfo-link-button"
                         @click="goToWorkInfoLog()">
                <i class="el-icon-link"></i>
                <span>查看该用户的职业信息</span>
              </el-button>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="沟通方式"
                      prop="communicate_type">
          <el-select v-model="form.communicate_type"
                     class="width-max"
                     placeholder="请选择沟通方式">
            <el-option v-for="(value,index) in options.communicate_type"
                       :label="value.keyword"
                       :value="value.id"
                       :key="index">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="沟通状态"
                      prop="connect_status">
          <el-select v-model="form.connect_status"
                     class="width-max"
                     placeholder="请选择沟通状态"
                     @change="handleConnectStatusChange">
            <el-option v-for="(value,index) in options.connect_status"
                       :label="value.keyword"
                       :value="value.id"
                       :key="index">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="showAbnormalReason"
                      label="异常原因"
                      prop="abnormal_reason">
          <el-select v-model="form.abnormal_reason"
                     class="width-max"
                     placeholder="请选择异常原因">
            <el-option v-for="(value,index) in options.abnormal_reason"
                       :label="value.keyword"
                       :value="value.id"
                       :key="index">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="showAbnormalReason" />

        <el-form-item label="推荐方"
                      prop="recommend_source">
          <el-select v-model="form.recommend_source"
                     class="width-max"
                     clearable
                     placeholder="请选择推荐方">
            <el-option v-for="(value,index) in options.recommend_source"
                       :label="value.keyword"
                       :value="value.id"
                       :key="index">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="推荐方详情"
                      prop="recommend_source_detail">
          <el-input class="width-max"
                    clearable
                    placeholder="请输入推荐方详情"
                    v-model="form.recommend_source_detail">
          </el-input>
        </el-form-item>

        <el-form-item label="做单意向"
                      prop="task_intention">
          <el-select v-model="form.task_intention"
                     class="width-max"
                     clearable
                     placeholder="请选择做单意向">
            <el-option v-for="(value,index) in options.task_intention"
                       :label="value.keyword"
                       :value="value.id"
                       :key="index">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="做单意向备注"
                      prop="task_intention_remark">
          <el-input type="textarea"
                    class="width-max"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    placeholder="有：填写任务 ID；无：说明原因"
                    v-model="form.task_intention_remark">
          </el-input>
        </el-form-item>

        <el-form-item label="推荐他人意向"
                      prop="recommend_other_intention">
          <el-select v-model="form.recommend_other_intention"
                     class="width-max"
                     clearable
                     placeholder="请选择推荐他人意向">
            <el-option v-for="(value,index) in options.recommend_other_intention"
                       :label="value.keyword"
                       :value="value.id"
                       :key="index">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="推荐意向备注"
                      prop="recommend_remark">
          <el-input type="textarea"
                    class="width-max"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    placeholder="填写姓名 / 联系方式；无：填写原因"
                    v-model="form.recommend_remark">
          </el-input>
        </el-form-item>

        <el-form-item class="full-row"
                      label="记录详情"
                      prop="record_detail">
          <el-input type="textarea"
                    class="width-max"
                    :autosize="{ minRows: 3, maxRows: 6 }"
                    placeholder="请输入沟通记录详情"
                    v-model="form.record_detail">
          </el-input>
        </el-form-item>
      </div>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="onSubmit()">保存</el-button>
      <el-button @click="closeAndRefresh()">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
const CONNECT_STATUS_EXCEPTION = 2
const NULLABLE_SELECT_FIELDS = [
  'communicate_type',
  'connect_status',
  'abnormal_reason',
  'recommend_source',
  'task_intention',
  'recommend_other_intention',
]
const NULLABLE_TEXT_FIELDS = [
  'recommend_source_detail',
  'task_intention_remark',
  'recommend_remark',
  'record_detail',
]
const FORM_FIELDS = [
  'record_id',
  'userid',
  'communicate_type',
  'connect_status',
  'abnormal_reason',
  'recommend_source',
  'recommend_source_detail',
  'task_intention',
  'task_intention_remark',
  'recommend_other_intention',
  'recommend_remark',
  'record_detail',
]

const createDefaultForm = () => ({
  record_id: null,
  userid: null,
  communicate_type: null,
  connect_status: null,
  abnormal_reason: null,
  recommend_source: null,
  recommend_source_detail: null,
  task_intention: null,
  task_intention_remark: null,
  recommend_other_intention: null,
  recommend_remark: null,
  record_detail: null,
})

const buildFormData = (record = {}) => {
  const form = createDefaultForm()
  FORM_FIELDS.forEach((field) => {
    if (Object.prototype.hasOwnProperty.call(record, field)) {
      form[field] = record[field]
    }
  })
  return form
}

export default {
  name: 'UserCommunicateForm.vue',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    lockUserId: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    record_obj: {
      type: Object,
      default: () => ({})
    },
  },
  data () {
    const validateAbnormalReason = (rule, value, callback) => {
      if (Number(this.form.connect_status) === CONNECT_STATUS_EXCEPTION && !value) {
        callback(new Error('异常原因不能为空'))
        return
      }
      callback()
    }

    return {
      form: createDefaultForm(),
      formRules: {
        userid: [{required: true, message: '用户不能为空', trigger: 'change'}],
        communicate_type: [{required: true, message: '沟通方式不能为空', trigger: 'change'}],
        connect_status: [{required: true, message: '沟通状态不能为空', trigger: 'change'}],
        abnormal_reason: [{validator: validateAbnormalReason, trigger: 'change'}],
      },
    }
  },
  watch: {
    record_obj: {
      immediate: true,
      handler (value) {
        Object.assign(this.form, buildFormData(value))
        if (!this.showAbnormalReason) {
          this.form.abnormal_reason = null
        }
      }
    }
  },
  computed: {
    ...Vuex.mapState({
      options: state => state.users.userOptions,
    }),
    showAbnormalReason () {
      return Number(this.form.connect_status) === CONNECT_STATUS_EXCEPTION
    },
    showWorkInfoLink () {
      return !!this.form.userid
    },
  },
  methods: {
    ...request.map(['getUserTable', 'getUserDetail_']),
    onSubmit () {
      this.$refs.communicateForm.validate((valid) => {
        if (valid) {
          this.form.record_id ? this.updateServiceRecord() : this.addNewCustomerRecord()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    addNewCustomerRecord () {
      return request.common('addCustomerService', this.getSubmitParams()).then(() => {
        this.$message({showClose: true, message: '沟通记录添加成功', type: 'success'})
        this.closeAndRefresh()
      })
    },
    updateServiceRecord () {
      return request.common('modifyCustomerService', this.getSubmitParams()).then(() => {
        this.$message({showClose: true, message: '沟通记录修改成功', type: 'success'})
        this.closeAndRefresh()
      })
    },
    getSubmitParams () {
      const params = buildFormData(this.form)

      NULLABLE_SELECT_FIELDS.forEach((field) => {
        if (params[field] === '') {
          params[field] = null
        }
      })

      NULLABLE_TEXT_FIELDS.forEach((field) => {
        if (typeof params[field] === 'string' && params[field].trim() === '') {
          params[field] = null
        }
      })

      if (!this.showAbnormalReason) {
        params.abnormal_reason = null
      }

      params.call_type = null
      params.communicate_detail = null

      return params
    },
    handleConnectStatusChange (value) {
      if (Number(value) !== CONNECT_STATUS_EXCEPTION) {
        this.form.abnormal_reason = null
        if (this.$refs.communicateForm) {
          this.$refs.communicateForm.clearValidate('abnormal_reason')
        }
      }
    },
    goToWorkInfoLog () {
      if (!this.form.userid) {
        return
      }
      const routeData = this.$router.resolve({
        path: '/users/detail/workinfo-log',
        query: {userid: this.form.userid},
      })
      window.open(routeData.href, '_blank')
    },
    closeAndRefresh () {
      if (this.$refs.communicateForm) {
        this.$refs.communicateForm.resetFields()
      }
      Object.assign(this.form, createDefaultForm())
      this.$emit('closeAndRefresh')
    },
  },
}
</script>

<style scoped>
.workinfo-link-button {
  padding: 0;
}

.communicate-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  column-gap: 20px;
  margin-left: 0;
}

.communicate-form-grid > .el-form-item {
  width: auto;
  margin-left: 0;
  margin-bottom: 16px;
}

.communicate-form-grid > .full-row {
  grid-column: 1 / -1;
}

.communicate-form-grid >>> .width-max,
.communicate-form-grid >>> .width-max .el-select,
.communicate-form-grid >>> .width-max .el-input,
.communicate-form-grid >>> .width-max .el-input__inner,
.communicate-form-grid >>> .width-max .el-textarea,
.communicate-form-grid >>> .width-max .el-textarea__inner {
  width: 100%;
}

.communicate-form-grid >>> .el-textarea__inner {
  min-height: 88px;
}

.user-communicate-dialog {
  max-width: calc(100vw - 32px);
  max-height: calc(100vh - 10vh);
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
}

.user-communicate-dialog >>> .el-dialog__body {
  flex: 1;
  overflow-y: auto;
  padding-top: 20px;
}

@media (max-width: 1200px) {
  .communicate-form-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/users/components/UserCommunicateForm.vue